import { repository, baseURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/order/findAll')
    return data
  },

  async get(id) {
    const { data } = await repository.get(baseURL + '/order/' + id)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/order', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/order', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/order/' + id)
  }
}